import Immutable from 'immutable';
import { search } from "../../common/utils/algolia";
import { generateSearchId } from "../../common/utils/ids";
import resolveDataErrorMessages from "../../common/utils/resolveDataErrorMessages";
import { HOME } from "../config/discoverCollections";
import { DiscoveryCollectionsTask, DiscoveryFacetsTask } from "../telemetry/tasks";
export const RETRIEVE_COLLECTIONS_DATA = 'DISCOVER_RETRIEVE_COLLECTIONS_DATA';
export const RECEIVE_COLLECTIONS_DATA = 'DISCOVER_RECEIVE_COLLECTIONS_DATA';
export const COLLECTIONS_DATA_ERROR = 'DISCOVER_COLLECTIONS_DATA_ERROR';
export const RECEIVE_FACETS = 'DISCOVER_RECEIVE_FACETS';
export const FACETS_DATA_ERROR = 'DISCOVER_FACETS_DATA_ERROR';

function retrieveCollectionsData() {
  return {
    type: RETRIEVE_COLLECTIONS_DATA
  };
}

function receiveCollectionsData({
  data
}) {
  return {
    type: RECEIVE_COLLECTIONS_DATA,
    data
  };
}

function collectionsDataError({
  dataErrorMessages
}) {
  return {
    type: COLLECTIONS_DATA_ERROR,
    dataErrorMessages
  };
}

function receiveFacets({
  facets
}) {
  return {
    type: RECEIVE_FACETS,
    facets
  };
}

function facetsDataError({
  dataErrorMessages
}) {
  return {
    type: FACETS_DATA_ERROR,
    dataErrorMessages
  };
}

const doCollectionSearch = ({
  algoliaClient,
  collection,
  environment,
  filters,
  applyOverrides
}) => Promise.all(collection.get('resolveQueries')({
  filters,
  applyOverrides
}).map(q => search({
  algoliaClient,
  environment,
  filters: q.get('filters'),
  numHits: collection.get('numResults'),
  applyOverrides: q.get('applyOverrides')
}))).then(data => Immutable.Map({
  hits: collection.get('resolveHits')({
    hits: Immutable.List(data).map(d => d.getIn(['searchResults', 'hits']))
  }),
  searchId: generateSearchId()
}));

export function doRetrieveData({
  algoliaClient,
  environment,
  filters,
  applyOverrides,
  resolveAlgoliaQueryFilterOverrides,
  discoverCollectionsConfig,
  featureFlags
}) {
  return dispatch => {
    dispatch(retrieveCollectionsData());
    DiscoveryFacetsTask.start();
    search({
      algoliaClient,
      applyOverrides,
      environment,
      filters,
      resolveAlgoliaQueryFilterOverrides,
      featureFlags
    }).then(data => {
      dispatch(receiveFacets({
        facets: data.get('facets')
      }));
      DiscoveryFacetsTask.succeeded();
    }, error => {
      if (error.debugData) {
        console.error('Search error, debug data:', error.debugData);
        console.error(error.debugData);
      }

      const dataErrorMessages = resolveDataErrorMessages(error);
      dispatch(facetsDataError({
        dataErrorMessages
      }));
      DiscoveryFacetsTask.failed(error);
    });
    DiscoveryCollectionsTask.start();
    Promise.all(discoverCollectionsConfig.get(filters.get('product', HOME)).map(collection => doCollectionSearch({
      algoliaClient,
      collection,
      environment,
      filters,
      applyOverrides
    }).then(data => Immutable.Map({
      key: collection.get('key'),
      data
    }))).toJS()).then(data => {
      dispatch(receiveCollectionsData({
        data: Immutable.List(data).reduce((acc, d) => acc.set(d.get('key'), d.get('data')), Immutable.Map())
      }));
      DiscoveryCollectionsTask.succeeded();
    }, error => {
      if (error.debugData) {
        console.error('Search error, debug data: ');
        console.error(error.debugData);
      }

      const dataErrorMessages = resolveDataErrorMessages(error);
      dispatch(collectionsDataError({
        dataErrorMessages
      }));
      DiscoveryCollectionsTask.failed(error);
    });
  };
}